import React from 'react';
import { selectLogo } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, BaasicInput } from 'core/components';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import { isSome } from 'core/utils';
import BasicRadio from 'themes/components/forms/BasicRadio';
import Countdown from 'react-countdown';

const TwoStepAuthenticationTemplate = ({
	t,
	viewStore: {
		form,
		loading,
		smsOption,
		onToggleVerificationOption,
		sendVerificationCode,
		resetTimerData,
		verificationCodeSent,
		errorMessage,
		resendMessage,
		missingPhoneNumber,
		phoneNumber,
		timer,
		onUserPhoneChange,
		hidePhoneNumber,
		countryDropdownStore
	},
}) => {
	const logo_show = selectLogo();

	const addZeroBefore = number => {
		return (number < 10 ? '0' : '') + number;
	};

	const renderer = ({ minutes, seconds }) => {
		minutes = addZeroBefore(minutes);
		seconds = addZeroBefore(seconds);
		return (
			<p className="type--color--warning type--pre-line spc--bottom--sml">{t(errorMessage, { minutes, seconds })}</p>
		);
	};

	return (
		<main className="body--secondary">
			<section className="w--400--px align--h--center padd--top--med">
				<img className="w--200--px display--b align--h--center" src={logo_show} alt="Logo" />
				<form className="form card spc--top--med" onSubmit={form.onSubmit}>
					<div className="card__header">
						<h3>{t('TWOSTEPAUTHENTICATION.TITLE')}</h3>
					</div>
					{!verificationCodeSent && (
						<React.Fragment>
							<div className="card__body">
								<div className="spc--bottom--sml">{t('TWOSTEPAUTHENTICATION.MESSAGE')}</div>
								<div className="spc--bottom--sml">
									<ButtonGroup className="k-button-group--carrier">
										<Button
											togglable={true}
											selected={smsOption}
											onClick={() => onToggleVerificationOption(true)}
											type="button"
											icon="icon icon--sms"
										>
											<BasicRadio
												field={form.$('sms')}
												value={smsOption}
												name="sms"
												label={'TWOSTEPAUTHENTICATION.SMS'}
												className="input--radio"
											></BasicRadio>
										</Button>
										<Button
											togglable={true}
											selected={!smsOption}
											onClick={() => onToggleVerificationOption(false)}
											type="button"
											icon="icon icon--phone"
										>
											<BasicRadio
												field={form.$('voiceCall')}
												value={!smsOption}
												name="voiceCall"
												label={'TWOSTEPAUTHENTICATION.VOICECALL'}
												className="input--radio"
											></BasicRadio>
										</Button>
									</ButtonGroup>
								</div>
								{/* Missing Phone Number */}
								{missingPhoneNumber && (
									<React.Fragment>
										<p className="spc--bottom--sml">{t('TWOSTEPAUTHENTICATION.MISSINGPHONENUMBER')}</p>
										<BaasicDropdown dropdownStore={countryDropdownStore} className="spc--bottom--sml w--100" />
										<BaasicInput
											field={form.$('phoneNumber')}
											autoFocus
											disabled={!missingPhoneNumber || !form.$('countryCodeId').value}
											showCheckmark={false}
											onKeyUp={onUserPhoneChange(form.$('phoneNumber').value)}
										/>
									</React.Fragment>
								)}
							</div>
							<div className="card__footer">
								{errorMessage && isSome(timer) && (
									<Countdown
										autoStart={true}
										date={timer.date + timer.delay}
										renderer={renderer}
										onComplete={() => resetTimerData()}
									/>
								)}
								{errorMessage && !isSome(timer) && (
									<React.Fragment>
										<p className="type--color--warning spc--bottom--sml">{t(errorMessage)}</p>
									</React.Fragment>
								)}
								<button
									type="button"
									className="btn btn--med btn--primary"
									onClick={() => sendVerificationCode()}
									disabled={loading || isSome(timer)}
								>
									{loading ? (
										<div className="spinnercont spc--right--sml">
											<div className="spinner"></div>
										</div>
									) : null}
									{t('TWOSTEPAUTHENTICATION.SENDVERIFICATIONCODE')}
								</button>
							</div>
						</React.Fragment>
					)}
					{verificationCodeSent && (
						<React.Fragment>
							<div className="card__body">
								<div className="spc--bottom--sml">
									{t('TWOSTEPAUTHENTICATION.CODESENTMESSAGE') + `${hidePhoneNumber(phoneNumber)}`}
								</div>
								<BaasicInput field={form.$('verificationCode')} autoFocus showCheckmark={false} />
								{form.error && (
									<React.Fragment>
										<p className="type--color--warning spc--bottom--sml">{t(form.error)}</p>
									</React.Fragment>
								)}
								<div className="spc--bottom--sml">
									<div className="flex flex--primary flex--align--baseline">
										<React.Fragment>
											<p>{t('TWOSTEPAUTHENTICATION.DIDNTRECEIVEACODE')}</p>
										</React.Fragment>
										<button
											type="button"
											className="btn btn--ghost type--wgt--bold"
											onClick={() => sendVerificationCode(true)}
											disabled={loading}
										>
											{t('TWOSTEPAUTHENTICATION.RESEND')}
										</button>
									</div>
									{resendMessage && !loading && (
										<React.Fragment>
											<p className="type--tny type--color--success">{t('TWOSTEPAUTHENTICATION.CODERESENT')}</p>
										</React.Fragment>
									)}
								</div>
								{errorMessage && <p className="type--color--warning spc--bottom--sml">{t(errorMessage)}</p>}
								<button className="btn btn--med btn--primary" type="submit" disabled={loading}>
									{loading ? (
										<div className="spinnercont spc--right--sml">
											<div className="spinner"></div>
										</div>
									) : null}
									{t('TWOSTEPAUTHENTICATION.VERIFYCODE')}
								</button>
							</div>
						</React.Fragment>
					)}
				</form>
			</section>
		</main>
	);
};

export default defaultTemplate(TwoStepAuthenticationTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/membership/pages/TwoStepAuthenticationTemplate.jsx